import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import LandingPageContainer from "./pages/LandingPageContainer";
import config from "./config";
import i18n from "./i18n";

const generateSupportedRoutes = () => {
  const routes = [];

  routes.push("/", "/en");

  ["it", "en"].forEach((lang) => {
    const routesData = i18n.getResourceBundle(lang, "routes");
    if (routesData?.sectionToSlug) {
      Object.values(routesData.sectionToSlug).forEach((slug) => {
        if (slug) {
          const basePath = lang === "en" ? "/en" : "";
          routes.push(`${basePath}/${slug}`);
        }
      });
    }
  });

  return routes;
};

const SUPPORTED_ROUTES = generateSupportedRoutes();

function LanguageSwitcher() {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location ? location.pathname : "/";
    if (currentPath.startsWith("/en")) {
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("it");
    }
  }, [location]);

  return null;
}

export default function AppRouter() {
  const { t } = useTranslation();

  return (
    <Router>
      <LanguageSwitcher />
      <div className="app">
        <Helmet>
          <title>{config.APP_NAME}</title>
          <meta charSet="utf-8" />
          <meta name="description" content={t("metas:description")} />
        </Helmet>
        <Switch>
          {SUPPORTED_ROUTES.map((path) => (
            <Route
              key={path}
              path={path}
              exact
              component={LandingPageContainer}
            />
          ))}
        </Switch>
      </div>
    </Router>
  );
}
